import { render, staticRenderFns } from "./SidebarAsMobileLayer.vue?vue&type=template&id=12a38ea1&scoped=true"
import script from "./SidebarAsMobileLayer.vue?vue&type=script&lang=ts"
export * from "./SidebarAsMobileLayer.vue?vue&type=script&lang=ts"
import style0 from "./SidebarAsMobileLayer.vue?vue&type=style&index=0&id=12a38ea1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a38ea1",
  null
  
)

export default component.exports